import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TipoUsuario } from 'src/app/models/common/enumModel';
import { IIdentityResultModel } from 'src/app/models/interfaces/seguridad/IIdentityResultModel';
import { IUsuarioCambiarPasswordModel } from 'src/app/models/interfaces/seguridad/IUsuarioCambiarPasswordModel';
import { LoginModel } from 'src/app/models/seguridad/LoginModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {
  private configContratistaUrl = [environment.apiSecurityContratistaUrl, 'Identity/authentication'].join('/');
  private configEmpleadoUrl = [environment.apiSecurityEmpleadoUrl, 'Identity/authentication'].join('/');
  
  constructor(
    private http: HttpClient
  ) { }

  login(model: LoginModel, idServicio: TipoUsuario) {
    if(idServicio === TipoUsuario.Contratista){
      return this.http.post<IIdentityResultModel>(`${this.configContratistaUrl}`, model);
    }
    else{
      return this.http.post<IIdentityResultModel>(`${this.configEmpleadoUrl}`, model);
    }
  }
}
